import React, { useEffect } from "react";
import BasePopup from "../page/components/MiniGame/components/Popup";
import styled from "styled-components";
import bgPopupIntroNewYear from "../assets/images/Mini-Game/new-year-2025/invite-popup.png";
import iconClosePopup from "../assets/images/Mini-Game/icon-close-popup.svg";
import { useLocation, useNavigate } from "react-router";
import PATH from "../config/PATH";
import { ID_TAB_MINI_GAME } from "../helper/const";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { curStateMiniGame } from "../Redux/selector";
import { getDataAwardListMiniGame } from "../Redux/futures/mini-game/action";

export default function ModalPromotion({ open, onCancel }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);

  useEffect(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      dispatch(getDataAwardListMiniGame());
    }
  }, []);

  if (_.includes(location.pathname, PATH.MINI_GAME)) {
    return null;
  }

  const handleToMinigame = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`);
    onCancel();
  };

  return (
    <Div>
      <BasePopup
        className="popup-invite position-relative"
        // getContainer={true}
        isMaxWidth={true}
        open={open}
        onCancel={onCancel}
        maskClosable={true}
      >
        <ContainerPromotion className="position-relative">
          <img
            src={bgPopupIntroNewYear}
            alt=""
            className="bg-popup-intro"
            onClick={handleToMinigame}
          />
          <img
            src={iconClosePopup}
            alt=""
            className="rule-mini-close button-hover__minigame"
            onClick={onCancel}
          />
        </ContainerPromotion>
      </BasePopup>
    </Div>
  );
}

const ContainerPromotion = styled.div`
  .bg-popup-intro {
    border-radius: 16px;
    cursor: pointer;
    transition: 0.3s ease-in-out transform;

    @media (max-width: 576px) {
      max-width: 90dvw !important;
      margin: 0 auto;
      min-height: 415px !important;
    }

    &:hover {
      transform: scale(1.01);
    }
  }

  .rule-mini-close {
    position: absolute !important;
    right: 0 !important;
    top: 0 !important;
    transform: translate(50%, -50%);

    @media (max-width: 576px) {
      transform: translate(40%, -50%);
    }
  }
`;

const Div = styled.div`
  .rule-mini-close {
    position: absolute;
    z-index: 100;
    right: -9px;
    top: 15px;
  }

  .bg-popup-intro {
    max-width: 480px;
    max-height: 715px;
  }

  .position-relative {
    position: relative;
    width: max-content;
    margin: 0 auto;
  }

  @media (max-width: 576px) {
    .bg-popup-intro {
      max-width: 100%;
      min-height: 680px;
    }

    .position-relative {
      width: inherit;
    }
  }
`;
